import { render, staticRenderFns } from "./ReferralTable.vue?vue&type=template&id=2b3e93b8"
import script from "./ReferralTable.vue?vue&type=script&lang=ts"
export * from "./ReferralTable.vue?vue&type=script&lang=ts"
import style0 from "./ReferralTable.vue?vue&type=style&index=0&id=2b3e93b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports